export const conditionFindings = {
  stepLabel: 'Findings',
  better: 'Better',
  same: 'Same',
  worse: 'Worse',
  redFlagTitle: (label: string) => `Red flag: ${label}`,
  redFlagIntro: "A positive red flag needs a recommended action and the patient's response before you continue.",
  recommendedAction: 'Recommended action',
  patientResponse: 'Patient response (including a refusal)',
  editResponse: 'Edit response',
  save: 'Save',
  note: 'Note (optional)',
  normal: 'Normal',
  clear: 'Clear',
  clearTitle: (name: string) => `Clear the findings for ${name}?`,
  clearMessage: 'Every answer, value, red-flag response and note recorded here will be removed.',
  removeRedFlagTitle: 'Remove this red flag and its responses?',
  removeRedFlagMessage: (label: string) => `The recommended action and patient response recorded for ${label} will be removed.`,
  addNote: 'Add note',
  editNote: 'Edit note',
  responsesLine: (action: string, response: string) => `Recommended action: ${action} · Patient response: ${response}`,
  missing: (gaps: string) => `Before sign-off: ${gaps}.`,
  noQuestionSet: 'There is no question set for this condition. Write the assessment instead.',
  assessment: 'Assessment',
  universalTitle: 'Universal questions',
  noConditions: 'No conditions are designated for this patient.',
  removeTitle: 'Remove this condition?',
  removeMessage: (name: string) => `Findings recorded for ${name} will be removed.`,
  removeReasonMessage: (name: string) => `Findings recorded for ${name} will be removed unless it is also designated for CCM.`,
  thisCondition: 'this condition',
  remove: 'Remove',
  cancel: 'Cancel',
  obesityOnly: 'Obesity alone is a weaker anchor for CCM. Consider assessing another chronic condition as well.',
  saveFailed: 'Could not save the findings',
  outOfRange: (min: number, max: number | null) =>
    max === null ? `Enter a whole number from ${min}` : `Enter a whole number from ${min} to ${max}`,
  conditionNotAssessed: (name: string) => `${name}: no findings yet`,
  responsesNeeded: (label: string) => `${label}: recommended action and patient response needed`,
  valueNeeded: (label: string, value: string) => `${label}: ${value} needed`
} as const;
